// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { containerStyles } from "@awc/Overrides/Widgets/CheckoutShipping/CheckoutShippingPageContainer";
import { CHECKOUT_BREAKPOINT } from "@awc/XDL/constants";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

containerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr minmax(317px,446px);
        row-gap: 20px;
        column-gap: 18px;
        ${xScreen("lte", CHECKOUT_BREAKPOINT)} {
            grid-template-columns: 1fr;
            row-gap: 36px;
        }
    `,
};
containerStyles.headerGridItem = {
    css: css`
        grid-column: 1 / 3;
        ${xScreen("lte", CHECKOUT_BREAKPOINT)} {
            grid-column: 1 / 2;
            margin-bottom: -16px;
        }   
    `,
};
containerStyles.leftSection = {
    css: css`
        grid-column: 1 / 2;
        display: flex;
        flex-direction: column;
        row-gap: 24px;
        ${xScreen("lte", CHECKOUT_BREAKPOINT)} {
            row-gap: 36px;

        }
    `,
};
containerStyles.rightSection = {
    css: css`
        grid-column: 2 / 3;
        ${xScreen("lte", CHECKOUT_BREAKPOINT)} {
            grid-column: 1 / 2;
            grid-row: 2/3;
        }
    `,
};